import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';

const ImageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: ${breakpoints.sm}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ImageItem = styled.div`
  display: block;
`;

export { ImageContainer, ImageItem };
